import { newsFeed } from "@/mocks/homeData";

const toneMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-800",
  secondary: "bg-secondary-100 text-secondary-800",
  accent: "bg-accent-100 text-accent-800",
};

export default function NewsFeed() {
  return (
    <div className="rounded-lg border border-background-200/80 bg-background-50 overflow-hidden">
      <div className="flex items-center justify-between gap-3 border-b border-background-200/70 px-5 md:px-6 py-4">
        <div className="flex items-center gap-2.5">
          <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center text-lg">
            <i className="ri-article-line"></i>
          </span>
          <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">最新短讯</h3>
        </div>
        <span className="text-xs md:text-sm text-foreground-500 hidden sm:inline">每 5 分钟刷新一次</span>
      </div>

      <div className="divide-y divide-background-200/70">
        {newsFeed.map((item) => (
          <article key={item.id} className="p-5 md:p-6 hover:bg-background-100/70 transition-colors">
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-5">
              {item.image && (
                <a
                  href="#top"
                  className="w-full sm:w-44 md:w-52 h-40 sm:h-32 shrink-0 rounded-md overflow-hidden bg-background-200"
                >
                  <img
                    src={item.image}
                    alt={`${item.title} - 黑料官方短讯配图`}
                    title={`${item.title} 黑料官方`}
                    className="w-full h-full object-cover object-top"
                  />
                </a>
              )}

              <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-center gap-2.5">
                  <span className={`text-xs font-medium px-2.5 py-1 rounded-full ${toneMap[item.tone] ?? toneMap.primary}`}>
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500 flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.time}
                  </span>
                </div>

                <h4 className="mt-3">
                  <a
                    href="#top"
                    className="font-heading text-base md:text-lg font-bold text-foreground-950 hover:text-primary-700 transition-colors cursor-pointer"
                  >
                    {item.title}
                  </a>
                </h4>
                <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600">{item.summary}</p>

                <div className="mt-3.5 flex flex-wrap items-center gap-4 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-chat-3-line"></i>
                    {item.comments}
                  </span>
                  <a
                    href="#discussion"
                    className="ml-auto inline-flex items-center gap-1 text-primary-700 hover:text-primary-800 font-medium whitespace-nowrap cursor-pointer"
                  >
                    去讨论
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </div>
          </article>
        ))}
      </div>

      <div className="px-5 md:px-6 py-4 bg-background-100/70 border-t border-background-200/70 text-center">
        <a
          href="#top"
          className="inline-flex items-center gap-2 text-sm font-medium text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer"
        >
          <span>查看全部短讯</span>
          <i className="ri-arrow-down-line"></i>
        </a>
      </div>
    </div>
  );
}